import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import BriefingPage from "@/pages/BriefingPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import TicketsPage from "@/pages/TicketsPage";
import SystemPage from "@/pages/SystemPage";
import MailComposePage from "@/pages/MailComposePage";

const DEV_NO_AUTH = import.meta.env.DEV && import.meta.env.VITE_DEV_NO_AUTH === "1";

// 유효한 경로만 로그인 후 복귀 대상으로 저장 — 존재하지 않는 경로를 저장하면
// 로그인 → 404 → 다시 로그인 무한 루프가 발생한다.
const VALID_PATHS = new Set(["/briefing", "/dashboard", "/admin", "/tickets", "/system", "/mail-compose"]);

function ProtectedRoute({ children }) {
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();
  if (!isAuthed && !DEV_NO_AUTH) {
    const from = VALID_PATHS.has(location.pathname) ? location.pathname : "/briefing";
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return children;
}

// Backoffice IA (2026-08-21 정리) — Sidebar 기반 5개 최상위 그룹.
// /tickets — 기존 CxSection 재사용 (고객 문의·오류 제보)
// /system  — 기존 DevopsSection 재사용 (서비스 상태·시스템 오류)
// 레거시 경로(/about, /overview, /guide)는 모두 /briefing으로 redirect.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/briefing" replace />} />
        <Route path="briefing"  element={<BriefingPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="admin"     element={<AdminPage />} />
        <Route path="tickets"   element={<TicketsPage />} />
        <Route path="system"    element={<SystemPage />} />
        {/* 레거시 경로 — 모두 briefing으로 redirect */}
        <Route path="about"    element={<Navigate to="/briefing" replace />} />
        <Route path="overview" element={<Navigate to="/briefing" replace />} />
        <Route path="guide"    element={<Navigate to="/briefing" replace />} />
      </Route>
      <Route path="/mail-compose" element={<ProtectedRoute><MailComposePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/briefing" replace />} />
    </Routes>
  );
}
